export interface AgGridFilterModel {
    currentModel: FilterModel;
    options: FilterOption[];
}

export interface FilterModel {
    colId: string;
    type: string;
    filter: string | number | boolean | string[];
}

interface BaseFilterOption {
    title: string;
    colId: string;
}

export interface TextFilterOption extends BaseFilterOption {
    type:
        | AgGridFilterType.Equal
        | AgGridFilterType.Contains
        | AgGridFilterType.StartWith
        | AgGridFilterType.NotEqual;
    filter: string;
}

export interface NumberFilterOption extends BaseFilterOption {
    type:
        | AgGridFilterType.GreaterThan
        | AgGridFilterType.LessThan;
    filter: number;
}

export interface ClearFilterOption extends BaseFilterOption {
    type: AgGridFilterType.ClearFilter;
    filter: 'clear';
}

export type FilterOption = TextFilterOption | NumberFilterOption | ClearFilterOption;

export enum AgGridFilterType {
    ClearFilter = 'clear',
    Equal = 'equals',
    Contains = 'contains',
    StartWith = 'startsWith',
    GreaterThan = 'greaterThan',
    LessThan = 'lessThan',
    NotEqual = 'notEqual'
}

export enum AgGridServerFilterMap {
    'equals' = 'EQ',
    'contains' = 'LIKE',
    'greaterThan' = 'GT',
    'lessThan' = 'LT'
}

export enum AssetDropdownValues {
    USD = 'USD',
    TFUND = 'TFND'
}